import React from 'react';
import { useCart } from './CartContext';
import { useAuth } from '../auth/useAuth';
import '../styles/CartIcon.css';

const CartIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const { isAuthenticated } = useAuth();
  const { itemCount } = useCart();

  if (!isAuthenticated) return null;

  return (
    <button className="cart-icon-btn" onClick={onClick} type="button" aria-label="Shopping cart">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </svg>
      {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
    </button>
  );
};

export default CartIcon;
